export default class UrlParamsHelper {
  static convertUrlParamsToObject(url) {
    const params = url.split('?')[1];
    if (!params) return {};

    return JSON.parse(
      `{"${decodeURI(params)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`
    );
  }
}
